import React from 'react';
import { Snippet } from '@white-nl/instantsearch-components';

export default function Hit(results) {
  const { hit } = results;
  const {
    id,
    title,
    breadcrumbs,
    uri,
  } = hit;
  return (
    <div className="result-line" key={id}>
      <a href={window.Craft.getSiteUrl(uri, '')}>
        <div className="result-meta">
          {breadcrumbs
            && (
              <ul className="breadcrumb">
                {breadcrumbs.map((breadcrumb) => (
                  <li className="breadcrumb-item" key={breadcrumb?.id}>
                    {breadcrumb?.label}
                  </li>
                ))}
              </ul>
            )}
          <div className="result-line__uri">{`/${uri}`}</div>
        </div>
        <h4 className="result-line__title">{title}</h4>
        <Snippet
          hit={hit}
          attribute="content"
          classNames={{ root: 'result-line__description' }}
        />
      </a>
    </div>
  );
}
